module.exports = __webpack_public_path__ + "static/media/delia.6d52463a.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/img/delia.png
// module id = 1611
// module chunks = 0